import { ToastContainerProps } from "react-toastify";
import { ModuleEntity } from "../interface/sign-in";
import { GlassAccessory, TeamTypeEntity } from "./enum";

export const searchInputPlaceholder =
  "Type min. 3 letters and press enter to search";

export const maxLength10 = 10;
export const maxLength30 = 30;
export const maxLength45 = 45;
export const maxLength150 = 150;
export const maxLength100 = 100;
export const maxLength800 = 800;
export const maxLength10000 = 10000;
export const maxLength50000 = 50000;
export const maxLength5000000 = 5000000;
export const maxLength100000 = 100000;

export const backSpaceKeyCode = 8;
export const tabSpacekeyCode = 9;
export const deleteKeyCode = 46;
export const enterKeyCode = 13;
export const arrowLeftKeyCode = 37;
export const arrowUpKeyCode = 38;
export const arrowRightKeyCode = 39;
export const arrowDownKeyCode = 40;
export const copyKeyCode = 67;
export const pasteKeyCode = 86;
export const cutKeyCode = 88;
export const selectAllKeyCode = 65;
export const ctrlKeyCode = 17;
export const undoKeyCode = 90;

export const imageFileExtension = ["jpeg", "png", "jpg"];

export const imagePdfFileExtension = ["jpeg", "png", "jpg", "pdf"];

export const fileSize = "5,242,880";

export const toastOptObj: ToastContainerProps = {
  position: "top-center",
  autoClose: 3500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  theme: "colored",
};

export const rowsPerPageOptions = [10, 25, 50, 75];

export const statusLists: { name: string; code: boolean }[] = [
  { name: "Active", code: true },
  { name: "Inactive", code: false },
];

export const confirmationLists: { name: string; code: boolean }[] = [
  { name: "Yes", code: true },
  { name: "No", code: false },
];

export const accessoriesLists: { name: string; code: string }[] = [
  { name: "Skin", code: GlassAccessory.SKIN },
  { name: "Accessory", code: GlassAccessory.ACCESSORY },
];

export const teamLists: { name: string; code: string }[] = [
  { name: "Sales", code: TeamTypeEntity.SALES },
  { name: "Execution", code: TeamTypeEntity.EXECUTION },
  { name: "Socials", code: TeamTypeEntity.SOCIALS },
  { name: "Factory", code: TeamTypeEntity.FACTORY },
];

export const teamCategoryPermissionModuleNameMap: { [key: string]: ModuleEntity } = {
  [TeamTypeEntity.SALES]: "Access to Create Sales Users",
  [TeamTypeEntity.EXECUTION]: "Access to Create Execution Users",
  [TeamTypeEntity.SOCIALS]: "Access to Create Socials Users",
  [TeamTypeEntity.FACTORY]: "Access to Create Factory Users",
};

export const userPlatformLists: { name: string; code: string }[] = [
  { name: "Website", code: "web" },
  { name: "MobileApp", code: "app" },
  { name: "Both", code: "both" },
  { name: "None", code: "none" },
];

export const allFeaturedModules = {
  offices: 'Offices',
  viewOfficeTerritories: 'View Office Territories',
  percentageUpdate: 'Percentage Update',
  countriesStatesCitiesMaster: 'Countries-States-Cities Master',
  pricingVersion: 'Pricing Version',
  dashboard: "Dashboard",
  wallOrders: "Waltz Orders",
  transactions: "Transactions",
  paymentHistory: "Payment History",
  settlements: "Settlements",
  draftTransactions: "Draft Transactions",
  refundPayment: "Refund Payment",
  refundPaymentHistory: "Refund Payment History",
  orderDue: "Order Due",
  panelOnly: "Panel Only",
  accessoryOnly: "Accessory Only",
  directory: "Directory",
  settings: "Settings",
  downloads: "Downloads",
  OnlineUsers: "Online Users",
  goPro: "Go Pro",
  goProAssetsModule: "Go Pro Assets Module",
  analytics: "Analytics",
  observationErrors: "Observation Errors",
  reports: "Reports",
  orderReport: "Order Report",
  generalSettings: "General Settings",
  states: "States",
  cities: "Cities",
  systems: "Systems",
  subSystems: "Sub System",
  systemTypes: "System Types",
  models: "Models",
  frameColors: "Frame Colors",
  handles: "Handles",
  locks: "Locks",
  designs: "Designs",
  grids: "Grids",
  users: "Users",
  waltzCategories: "Categories",
  waltzSubCategories: "Sub Categories",
  waltzFinishes: "Finishes",
  waltzVariants: "Variants",
  roleManagement: "Role Management",
  changePassword: "Change Password",
  PricingVersionsOrderWiseCounts: "Pricing Versions Order Wise Counts",
  campaign: 'Campaign',
  redFlag: "Red Flag",
  Meetings: "Meetings",
  JBLibrary: "JB Library",
  JBConnectApp: "JB Connect App",
  Tags: "Tags",
  Albums: "Albums",
  Photos: "Photos",
  UsersTracking: "Users Tracking",
  MeetingConfiguration: "Meeting Configuration",
  ProductionPlanning: "Production Planning",
  // AccountantWorkOrder: "Accountant Work Order",
  // ProductionWorkOrder: "Production Work Order",

  DraftWOs: "Draft WOs",
  AccountantWOs: "Accountant WOs",
  ProductionPlanWOs: "Production Plan WOs",
  ProductionTeamWOs: "Production Team WOs",
  SalepersonWOs: "Saleperson WOs",
  DispatchManagerWOs: "Dispatch Manager WOs",
  executionOrderDetail: "Execution Order Detail",
  workOrdersList: "Work Orders List",
  masterDa: "Master DA",
  documentation: "Documentation",
  socials: "Socials",
  stateToUserMapping: "State to User Mapping",
  drawing: "Drawing",
  transporter: "Transporter",
  insurancePolicy: "Insurance Policy",
  invoiceTnC: "Invoice T&C",
  invoices: "Invoices",
  creditNote: "Credit Note",
  eWayDetails: "eWayDetails",
  insuranceAgents: "Insurance Agents",
  HSNCodeNGSTMapping: "HSN Code & GST Mapping",
  Vision: "Vision",
  TBSTracker: "TBS Tracker",
  SendForTBS: "Send For TBS",
  TBSStore: "TBS Store",
  Department: "Department",
  Production: "Production",
  WhatToSupply: "What To Supply",
  WhyToSupply: "Why To Supply",
  ActionRequired: "Action Required",
  TrustSeal: "Trust Seal",
  MasterItem: "Master Item",
  DepartmentMaster: "Department Master",
  MasterTracker: "Master Tracker",
  WorkflowRoutes: "Workflow Routes",
  WorkCenter: "Work Center",
  WorkStation: "Work Station",
  NameTrack: "Name Track",
  WorkOrderHoldReason: "Work Order Hold Reason",
  SalesHeadHoldReason: "Sales Head Hold Reason",
  TBSCategory: "TBS Category",
  CSMaster: "CS Master",
  CSMasterTypes: "CS Master Types",
  BOMMapping: "BOM Mapping",
  LocationTracker: "Location Tracker",
  ProjectTracker: "Project Tracker",
  WOTracker: "WO Tracker",
  PaintJob: "Paint Jobs",
  RMProjection: "RM Projection",
  BOMMappingUOM: "BOM Mapping UOM",
};

export const noDataAvailableInTable = "No data available in table";

export const emptyMultiSelectSearchMessage = "No results found";

export const albumsFileExtension = ["jpg", "jpeg", "png", 'gif', 'webp', 'heic'];

export const fileExtensionNotAllowed = 'File type is not valid';

export const fileSizeExceeds = 'File size must be less than 25 MB';

export const FileExtensionInAlbum = ["jpg", "jpeg", "png", 'gif', 'webp', 'heic', 'ogg', 'ogv', 'mp4', 'm4v', 'strm', 'pdf', 'docx', 'xlsx', 'csv', 'pptx'];

export const AllowedVideoExtension = ['ogg', 'ogv', 'mp4', 'm4v', 'webm', 'webmv', 'strm'];

export const AllowedPDFExtension = ['pdf'];

export const AllowedWordExtension = ['docx'];

export const AllowedExcelExtension = ['xlsx', 'csv'];

export const AllowedPPTExtension = ['pptx'];

export const WordExcelPPTExtensions = ['docx', 'xlsx', 'csv', 'pptx']

export const ExtensionOtherThenWordExcelPPT = ["jpg", "jpeg", "png", 'gif', 'webp', 'heic', 'ogg', 'ogv', 'mp4', 'm4v', 'webm', 'webmv', 'strm', 'pdf']

export const fullDispatchFileExtension = ["jpg", "jpeg", "png", "gif", "webp", "heic", "ogg", "ogv", "mp4", "m4v", "xlsx", "docx", "ppt", "pdf"];

export const OfficeAllowedFileExtension = ["jpg", "jpeg", "png", "gif", "webp", "heic", "ogg", "ogv", "mp4", "m4v", "xlsx", "docx", "ppt", "pdf", "pptx", "doc", "xls"];

export const EducationModuleAllowedFileExtension: string[] = ["jpg", "jpeg", "png", "webp", "heic", "mp4", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf"];

export const SystemIconExtension = ["svg"];

export const cadFileExtension = ['dwg'];
